import { SvgIcon } from '@mui/material';
import { IconProps } from './types/iconTypes';
const ArrowUpIcon = ({
  color = '$neutrals-700',
  width = '24',
  height = '24',
  className
}: IconProps) => <SvgIcon className={className} width={`${width}px`} height={`${height}px`} viewBox={`0 0 ${width} ${height}`} data-sentry-element="SvgIcon" data-sentry-component="ArrowUpIcon" data-sentry-source-file="ArrowUpIcon.tsx">
		<path d="M12 5.99997L10.59 7.40997L6 2.82997L1.41 7.40997L-6.16331e-08 5.99997L6 -2.64406e-05L12 5.99997Z" fill={color} data-sentry-element="path" data-sentry-source-file="ArrowUpIcon.tsx" />
	</SvgIcon>;
export default ArrowUpIcon;